import { render, staticRenderFns } from "./HivesNavigation.vue?vue&type=template&id=61d75836&lang=pug&"
import script from "./HivesNavigation.vue?vue&type=script&lang=ts&"
export * from "./HivesNavigation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports